import { Divider, Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledDivider = styled(Divider)`
background: ${props => props.theme.firstColor} !important;
margin-top: -6px !important;
margin-bottom: 0px !important;
 &:before {
    background: ${props => props.theme.firstColor} !important;
    border-left: 2px solid rgba(34,36,38,.15) !important; 
    height: 100% !important;
 }

 &:after {
    background: ${props => props.theme.firstColor} !important;
    border-left: 2px solid rgba(34,36,38,.15) !important; 
    height: 100% !important;
 }

`
export const EmissionWrapper = styled.div`
width: 50%;
display: flex;
flex-direction: column;
gap: 20px;
  .title {
    font-size: 15px !important;
    font-weight: bold;
    margin-bottom: 1em;
  }
  .ui.checkbox.disabled label,
  .ui.checkbox input[disabled] + label {
    opacity: 0.9 !important;
  }
`

export const StyledSkeletonWrapper = styled.div`
padding: 1.25em 2em;
.skeleton-chart {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-end;
  height: 300px; 
  width: 100%;
  padding: 20px;
  background-color: #f5f5f5; 
  position: relative;
  overflow: hidden;
}
`
export const StyledPeriodSelect = styled(Dropdown)`
width: 260px !important;
max-width: 260px !important;
max-height: 1em !important;
 .divider.text { 
    white-space: nowrap !important;
    width: 180px !important;
    max-width: 190px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;  
 }
`